module.exports = __webpack_public_path__ + "img/ceo_way_skill_05.dc1e59eb.png";